import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "../../axiosClient/userApi";

type DeleteTagTypeArgs = {
    tagTypeId: string;
    /**
     * When true, sends `?force=true` so the backend strips orphaned
     * references from every taggable entity (and cascades child TagValues)
     * before deleting the type. Used by the "delete anyway" path of the
     * in-use confirmation modal.
     */
    force?: boolean;
};

export const useDeleteTagType = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ tagTypeId, force = false }: DeleteTagTypeArgs): Promise<void> => {
            const url = force ? `/api/tag_types/${tagTypeId}?force=true` : `/api/tag_types/${tagTypeId}`;
            await loggedInApiCall.delete(url);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(["getAllTagTypes"]);
            queryClient.invalidateQueries(["getAllTagValues"]);
            queryClient.invalidateQueries(["getAllEntityTags"]);
            queryClient.invalidateQueries(["tagStatistics"]);
        },
    });
};
